// Must match src/auth/middleware.js's ROLE_ORDER exactly. EMPLOYEE and
// INVESTOR are self-scoped portal roles (their own holdings only) and belong
// below AUDITOR, a full-register role — getting this order wrong is what let
// an EMPLOYEE account see the entire cap table and audit log.
export const ROLE_ORDER = ['VIEWER', 'EMPLOYEE', 'INVESTOR', 'AUDITOR', 'LEGAL', 'ADMIN', 'OWNER'];

export function roleAtLeast(actual, required) {
  return ROLE_ORDER.indexOf(actual) >= ROLE_ORDER.indexOf(required);
}
